module.exports = __webpack_public_path__ + "img/back.c991c6b1.png";